import { DEFAULT_FILL_OPACITY } from '../../../../core/constants.js';
import { ShapeColor } from '../../../../core/types/color-palette.js';
import { getOpacity } from '../../../../core/utils/getOpacity.js';
import { SeriesMetadata } from '../../../types/timeseries.js';

export const getAreaStyle = (
  seriesMetadata: SeriesMetadata,
  highlightedSeriesId?: string[],
): ShapeColor => {
  if (!highlightedSeriesId) {
    return {
      color: seriesMetadata.color.Default,
      opacity: DEFAULT_FILL_OPACITY,
    };
  }

  const isCurrentHighlighted = highlightedSeriesId.includes(seriesMetadata.id);

  return {
    color: seriesMetadata.color.Default,
    opacity: getOpacity(isCurrentHighlighted),
  };
};
